/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import type {
  GetApiV1LocationCitiesQueryResponse,
  GetApiV1LocationCities401,
  GetApiV1LocationCities500,
} from "../../types/locationCityController/GetApiV1LocationCities.ts";
import { queryOptions, useQuery } from "@tanstack/react-query";
import { getApiV1LocationCities } from "../../clients/locationCityController/getApiV1LocationCities.ts";

export const getApiV1LocationCitiesQueryKey = () =>
  [{ url: "/api/v1/location/cities" }] as const;

export type GetApiV1LocationCitiesQueryKey = ReturnType<
  typeof getApiV1LocationCitiesQueryKey
>;

export function getApiV1LocationCitiesQueryOptions(
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getApiV1LocationCitiesQueryKey();
  return queryOptions<
    GetApiV1LocationCitiesQueryResponse,
    ResponseErrorConfig<GetApiV1LocationCities401 | GetApiV1LocationCities500>,
    GetApiV1LocationCitiesQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getApiV1LocationCities({
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @description Retorna todas as cidades cadastradas com estado e país, ordenadas por nome. **(Requer Authorization para autenticação)**
 * @summary Listar cidades (Requer Authorization para autenticação)
 * {@link /api/v1/location/cities}
 */
export function useGetApiV1LocationCities<
  TData = GetApiV1LocationCitiesQueryResponse,
  TQueryData = GetApiV1LocationCitiesQueryResponse,
  TQueryKey extends QueryKey = GetApiV1LocationCitiesQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetApiV1LocationCitiesQueryResponse,
        ResponseErrorConfig<
          GetApiV1LocationCities401 | GetApiV1LocationCities500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getApiV1LocationCitiesQueryKey();

  const query = useQuery(
    {
      ...getApiV1LocationCitiesQueryOptions(config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<GetApiV1LocationCities401 | GetApiV1LocationCities500>
  > & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
